"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Q-REF 101: How is the care plan funded without depleting my estate?",
  answer: "We utilize a structured asset-integration model. By coordinating home equity, aircraft valuation, and existing savings, we create a self-sustaining liquidity pool. This ensures your care is fully funded while preserving the core of your estate for your heirs or chosen legacy."
}, {
  question: "Q-REF 204: Can I remain in my airpark home if I lose my medical certificate?",
  answer: "Affirmative. Our primary mission is 'Aging in Hangar.' We deploy a dedicated Care Advisor to manage logistics, ensuring your home environment is adapted for long-term safety while maintaining your proximity to the runway and aviation community."
}, {
  question: "Q-REF 309: What happens to my aircraft if I can no longer fly solo?",
  answer: "We initiate a 'Right Seat Transition.' We pair you with qualified, vetted pilots who operate your aircraft, allowing you to remain in the cockpit as a flight deck participant. If a sale becomes necessary, we structure lease-back programs so you never lose access to the sky."
}, {
  question: "Q-REF 412: How does the Care Advisor coordinate with my medical team?",
  answer: "Your Care Advisor acts as the Mission Commander. They synchronize with your physicians to ensure care delivery matches your health status, managing everything from medication logistics to specialized in-home nursing, all while keeping you in command of your daily flight plan."
}];
export default function PreFlightBriefingFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262991" id="pre-flight-briefing-faq" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="page-container">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 uppercase">
              Pre-Flight Briefing
            </h2>
            <p className="text-muted-foreground text-lg font-default">
              Technical specifications and operational procedures for your lifetime care plan.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border bg-card rounded-md px-4 md:px-6 data-[state=open]:border-primary data-[state=open]:shadow-lg transition-all duration-200">
                <AccordionTrigger className="font-default text-base md:text-lg font-bold hover:no-underline hover:text-primary py-5 md:py-6 text-left tracking-tight">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-lg leading-relaxed pb-6 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}